import React from 'react';
import { Image } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

import { listMultiItem } from 'components/banners/DisplayItems';
import { getAllCampaignTypeTitle } from 'components/campaign/campaignCreation/CreateCampaignStepOneConfigs';
import { DISPLAY_TARGET_CUSTOMER_TYPE, TARGET_CUSTOMER_TYPE, WEEKDAY } from 'config/CustomEnums';
import { 
  getDisplayRecurringPeriod,
} from 'models/CreateCampaignModel';

import { removeDuplicatesByFieldFromArray } from 'utils';
import { getReadablePeriod } from 'utils/TimeFormatUtil';

import CheckOnIcon from 'assets/images/check_on.svg';

import '../../campaign/campaignCreation/ProfileSection.scss';
import { LinkSection } from 'components/base/LinkSection';


function ProfileSection({ data }) {
  const { getValues } = useFormContext() || {};
  const campaign = data || getValues() || {};
  const getListStrings = (list, linkPrefix = "", linkText = "View detail") => {
    if (list?.length === 0) {
      return null;
    }
    return (
      <ul>
        {list?.map((item) => (
          <li>
            {`[ID: ${item.pk}] ${item.name}`}
            <LinkSection
              link={linkPrefix ? `${linkPrefix}/${item.pk}/` : null}
              linkText={linkText}
              disableLink={linkPrefix === '/coupons' && item.toDelete}
              disableLinkText="Deleted"
            />
          </li>
        ))}
      </ul>
    );
  };

  const profileField = (field, value, showShortDescription = false) => {
    return (
      <>
        <label className="create-section-label create-section-label-bottom-space">
          {field}
        </label>
        <label className="create-section-field-input profile-section-label-bottom">
          {value || '-'}
        </label>
        {showShortDescription ? (
          <div className="display-over-all-limit-container">
            <Image src={CheckOnIcon} className="display-over-all-limit-icon" />
            <label className="display-over-all-limit">
              Display the overall limit in the campaign.
            </label>
          </div>
        ) : null}
      </>
    );
  };

  const getLinkedCouponSets = (rewardList) => {
    const result = [];
    if (!rewardList) {
      return result;
    }
    // eslint-disable-next-line array-callback-return
    rewardList.map((reward) => {
      if (reward.linkedCoupon) {
        result.push(reward.linkedCoupon);
      }
    });
    return removeDuplicatesByFieldFromArray(result, "pk");
  };

  return (
    <>
      <label className="create-section-title">PROPERTIES</label>
      {profileField(
        'Link to Earning rules',
        getListStrings(campaign.stampLinkedEarningRules, '/earns', 'View earning rule'),
      )}
      {profileField(
        'Link to coupon',
        getListStrings(getLinkedCouponSets(campaign.stampRewards), '/coupons', 'View coupon set'),
      )}
      {profileField('Total stamp quantity', campaign.totalStampQuantity)}
      {profileField(
        'Campaign type',
        getAllCampaignTypeTitle(campaign.campaignType),
      )}
      {profileField('Campaign category', getListStrings(campaign.categories))}
      {profileField(
        'Target customer',
        DISPLAY_TARGET_CUSTOMER_TYPE?.[campaign?.generalType] || campaign?.generalType,
      )}
      {profileField(
        'Static segment',
        getListStrings(
          campaign.generalType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT
            ? campaign.staticSegments
            : [],
          "/segments",
        ),
      )}
      {profileField(
        'Dynamic segment',
        getListStrings(
          campaign.generalType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT
            ? campaign.dynamicSegments
            : [],
          "/segments",
        ),
      )}
      {profileField(
        'Levels',
        getListStrings(
          campaign.generalType === TARGET_CUSTOMER_TYPE.LEVEL
            ? campaign.levels
            : [],
          "/levels"
        ),
      )}
      {
        profileField(
          "This is a recurring campaign for birthday",
          campaign.isBirthdayRecurringCampaign ? "Yes" : "No",
        )
      }
      {
        profileField("Recurring active period",
          getDisplayRecurringPeriod({
            isForBirth: campaign.isBirthdayRecurringCampaign,
            recurringDate: campaign?.recurringDate,
            prefix: "Active"
          }))
      }
      {
        profileField("Recurring visible period",
          getDisplayRecurringPeriod({
            isForBirth: campaign.isBirthdayRecurringCampaign,
            recurringDate: campaign?.recurringDate,
            prefix: "Visible"
          }))
      }
      {profileField(
        'Active period',
        getReadablePeriod(
          campaign.activeStartDate,
          campaign.activeEndDate,
          campaign.isAlwaysActivePeriod,
        ),
      )}
      {listMultiItem(
        'Blackout period (by period)',
        campaign.activePeriodValues?.map((item) =>
          getReadablePeriod(item.startDate, item.endDate, false),
        ),
      )}
      {listMultiItem(
        'Blackout period (by weekday)',
        campaign.activeWeekday?.map((item) => WEEKDAY[item]),
      )}
      {profileField(
        'Visible period',
        getReadablePeriod(
          campaign.visibleStartDate,
          campaign.visibleEndDate,
          campaign.isAlwaysVisiblePeriod,
        ),
      )}
      {profileField('Related brand', campaign.linkedBrand?.name)}
    </>
  );
}

export default ProfileSection;
